<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="benutzerverwaltung">
            <h2>Benutzerverwaltung</h2>
            <h3>
                Registrierte Benutzer
                <b-button v-if="checkRight('write')" :size="size" @click="dataCreate">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h3>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                busyText="Lädt Benutzer..."
                emptyText="Keine Benutzer gefunden"
            >
                <template v-slot:pw="{ row: row }">
                    <template v-if="row.value === 1">vorhanden</template>
                    <template v-else>Nicht vorhanden</template>
                </template>

                <template v-slot:group_id="{ row: row }">{{translateGroupId(row.value)}}</template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                    >Bearbeiten</b-button>
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                    >Löschen</b-button>
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                id="newModal"
                buttonText="Anlegen"
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder :fields="ioFields.new" :data="selected.data" />
                </template>
            </EditModal>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <b-tabs pills card vertical>
                    <b-tab title="Benutzer" active>
                        <template v-if="selected.data">
                            <FormGroupBuilder :fields="ioFields.edit" :data="selected.data" />
                        </template>
                    </b-tab>
                    <b-tab title="Rechte" disabled>
                        <!--<Tree :items="accessMap.data" @update="updateAccessMap" />-->
                    </b-tab>
                    <b-tab title="Einstellungen">
                        <template v-if="selected.data">
                            <UserSettings :id="selected.data.id" @update="updateSettings" />
                        </template>
                    </b-tab>
                </b-tabs>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import MitgliederSelect from "@/components/MitgliederSelect/MitgliederSelect";
import PasswordGenerationInput from "@/components/PasswordGenerationInput/PasswordGenerationInput";
import Tree from "@/components/Tree/Tree";
import UserSettings from "@/components/UserSettings/UserSettings";

import "./Benutzerverwaltung.scss";

const BenutzerverwaltungApi = ApiFactory.get("benutzerverwaltung");

export default {
    name: "benutzerverwaltung",
    mixins: [CommonView, Size],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder,
        MitgliederSelect,
        PasswordGenerationInput,
        Tree,
        UserSettings
    },
    data() {
        return {
            fields: [
                {
                    key: "mitglied_id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "pw",
                    label: "Passwort"
                },
                {
                    key: "fullname",
                    label: "Name",
                    sortable: true
                },
                {
                    key: "group_id",
                    label: "Gruppe",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: {
                new: [
                    {
                        key: "mitglied_id",
                        label: "Mitglied auswählen",
                        type: "mitgliederselect",
                        description:
                            "Bitte wählen Sie ein Mitglied aus der Liste aus, dass einen Verwaltungszugang erhalten soll"
                    },
                    {
                        key: "new_password",
                        label: "Passwort ändern",
                        type: "passwordgenerationinput",
                        description:
                            "Grundsätzlich werden nur automatisch generierte Passwörter verwendet. Um ein solches zu generieren kann die 'Passwort generieren' Schaltfläche benutzt werden",
                        meta: {
                            preFill: true
                        }
                    },
                    {
                        key: "send_password",
                        label: "Passwortbenachrichtigung",
                        type: "checkbox",
                        description:
                            "Soll dem neu angelegten Nutzer das erstellte Passwort zugesendet werden?",
                        text: "Passwort zusenden?",
                        checked_value: 1,
                        unchecked_value: 0
                    }
                ],
                edit: {
                    mitglied_id: {
                        key: "mitglied_id",
                        label: "ID",
                        type: "text",
                        disabled: true,
                        oneWay: true
                    },
                    fullname: {
                        key: "fullname",
                        label: "Name",
                        type: "text",
                        disabled: true,
                        oneWay: true
                    },
                    group_id: {
                        key: "group_id",
                        label: "Gruppe",
                        type: "select",
                        options: [],
                        placeholder: "Gruppe auswählen...",
                        description: "Gruppenauswahl für Benutzer"
                    },
                    pw: {
                        key: "pw",
                        label: "Passwort vorhanden",
                        type: "checkbox",
                        disabled: true,
                        oneWay: true,
                        checked_value: 1,
                        unchecked_value: 0
                    },
                    new_password: {
                        key: "new_password",
                        label: "Passwort ändern",
                        type: "passwordgenerationinput",
                        description:
                            "Grundsätzlich werden nur automatisch generierte Passwörter verwendet. Um ein solches zu generieren kann die 'Passwort generieren' Schaltfläche benutzt werden"
                    }
                }
            },
            api: BenutzerverwaltungApi,
            accessMap: {
                busy: false,
                data: [],
                new: null
            },
            groups: {
                busy: false,
                data: []
            },
            settings: {
                data: []
            }
        };
    },
    created() {
        this.fetchGroups();
    },
    watch: {
        "selected.data": {
            handler(value) {
                if (value) {
                    // this.fetchAccessMap(value.id);
                }
            },
            deep: true
        }
    },
    methods: {
        updateSettings(settings) {
            this.settings.data = settings;
        },
        async fetchGroups() {
            this.groups.busy = true;
            const response = await BenutzerverwaltungApi.getGroups();
            if (response.ok) {
                this.groups.data = response.json.collection;
                this.ioFields.edit.group_id.options = this.groups.data.map(
                    item => {
                        return {
                            value: item.id,
                            text: item.nicename
                        };
                    }
                );
                this.ioFields.edit.group_id.options.unshift({
                    value: null,
                    text: "Gruppe auswählen"
                });
            }
            this.groups.busy = false;
        },
        async fetchAccessMap(id) {
            if (id) {
                this.accessMap.busy = true;
                const response = await BenutzerverwaltungApi.getAccessMap(id);
                if (response.ok) {
                    var data = response.json.collection;
                    data = data.map(item => {
                        item.title = item.criteria;
                        return item;
                    });
                    this.accessMap.data = data;
                }
                this.accessMap.busy = false;
            }
        },
        updateAccessMap(items) {
            this.accessMap.new = items;
        },
        translateGroupId(id) {
            const foundItem = this.groups.data.find(item => item.id === id);
            if (foundItem) {
                return foundItem.nicename;
            }
        },
        process(item) {
            item.id = item.mitglied_id;
            item.fullname = item.vorname + " " + item.name;
            return item;
        },
        dataCreate() {
            const newObj = {};
            this.dataSet(newObj, "new", "Neu erstellen");
            this.$root.$emit("bv::show::modal", "newModal");
        },
        async additionalRequests(selectedItem) {
            /*const responseAccessMap = await BenutzerverwaltungApi.putAccessMap(
                selectedItem.id,
                this.accessMap.new
            );*/

            const responseSettings = await BenutzerverwaltungApi.putSettings(
                selectedItem.id,
                this.settings.data
            );

            return /*responseAccessMap.ok && */ responseSettings.ok;
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.fullname =
                response.json.vorname + " " + response.json.name;
            selectedItem.pw = response.json.pw;
            return selectedItem;
        },
        postProcessEdit(selectedItem, response) {
            delete selectedItem.new_password;
            this.accessMap.data = [];
            this.accessMap.new = null;
            return selectedItem;
        },
        postDataSet() {
            this.accessMap.data = [];
            this.accessMap.new = null;

            this.settings.data = [];
        }
    }
};
</script>
